import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import downloadIcon from "./assets/img/downloadIcon.png";
import * as XLSX from "xlsx";
import styles from "../Admin/assets/css/UserList.module.css";
import { prev_arrow, next_arrow } from "../assets/images";
import commoncss from "../Admin/assets/css/common.module.css";
import { BackgroundBlur } from "../utils/Popups";

export const URLProtected = ({ component }) => {
  const navigate = useNavigate();
  useEffect(() => {
    let adminAuth = localStorage.getItem("adminAuth");
    if (!adminAuth) {
      navigate("/admin/login/");
    }
  }, []);

  return component;
};

export const DownloadToExcel = ({ data, filename }) => {
  const handleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  return (
    <img
      src={downloadIcon}
      onClick={handleDownload}
      height="28px"
      style={{ cursor: "pointer" }}
      alt="Download"
    />
  );
};

// Updated Pagination component
export const Pagination = ({
  total,
  perPage,
  setPerPage,
  currPage,
  tPage,
  updatePage,
  prevPage,
  setCurrPage
}) => {
  const [tempPerPage, setTempPerPage] = useState(perPage);

  // Sync with parent's perPage value
  useEffect(() => {
    setTempPerPage(perPage);
  }, [perPage]);

  const handlePerPageChange = (e) => {
    const value = e.target.value;
    setTempPerPage(value);
  };

  const applyPerPageChange = () => {
    const value = parseInt(tempPerPage, 10);
    if (!isNaN(value) && value > 0) {
      setPerPage(value);
      setCurrPage(1); // Reset to first page
    } else {
      // Reset to previous valid value if invalid
      setTempPerPage(perPage);
    }
  };

  // Apply change when user presses Enter or blurs
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      applyPerPageChange();
    }
  };

  return (
    <div className={styles.pagination}>
      <p>Total {total}</p>
      <div className={styles.perPageInput}>
        <label>Items per page:</label>
        <input
          type="number"
          value={tempPerPage}
          onChange={handlePerPageChange}
          onBlur={applyPerPageChange}
          onKeyDown={handleKeyDown}
          min={1}
          style={{ width: "80px", marginLeft: "10px", borderRadius: "4px", border: "1px solid #ccc", padding: "5px" }}
        />
      </div>
      <p>
        {currPage} of {tPage}
      </p>
      <div className={styles.pageNum}>
        <img src={prev_arrow} onClick={updatePage} name="prev" alt="Prev" />
        {new Array(5).fill(0).map((_, index) => {
          return (
            prevPage + index <= tPage && (
              <span
                onClick={updatePage}
                key={index}
                className={
                  prevPage + index === currPage ? styles.selectedPage : ""
                }
              >
                {prevPage + index}
              </span>
            )
          );
        })}
        <img src={next_arrow} onClick={updatePage} name="next" alt="Next" />
      </div>
    </div>
  );
};


export const AlertPopup = ({ userBlock }) => {
  return (
    <React.Fragment>
      <div className={commoncss.alertBox}>
        <h1>Do you realy want to block the user?</h1>
        <div>
          <span
            onClick={userBlock}
            style={{ backgroundColor: "#019C89", color: "white" }}
          >
            Yes
          </span>
          <span onClick={userBlock}>No</span>
        </div>
      </div>
      <BackgroundBlur />
    </React.Fragment>
  );
};




// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import downloadIcon from "./assets/img/downloadIcon.png";
// import * as XLSX from "xlsx";
// import styles from "../Admin/assets/css/UserList.module.css";
// import { prev_arrow, next_arrow } from "../assets/images";
// import commoncss from "../Admin/assets/css/common.module.css";
// import { BackgroundBlur } from "../utils/Popups";

// export const URLProtected = ({ component }) => {
//   const navigate = useNavigate();
//   useEffect(() => {
//     let adminAuth = localStorage.getItem("adminAuth");
//     if (!adminAuth) {
//       navigate("/admin/login/");
//     }
//   }, []);

//   return component;
// };

// export const DownloadToExcel = ({ data, filename }) => {
//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//     XLSX.writeFile(wb, `${filename}.xlsx`);
//   };

//   return (
//     <img
//       src={downloadIcon}
//       onClick={handleDownload}
//       height="28px"
//       style={{ cursor: "pointer" }}
//       alt="Download"
//     />
//   );
// };

// export const Pagination = ({
//   total,
//   perPage,
//   currPage,
//   tPage,
//   updatePage,
//   prevPage,
// }) => {
//   return (
//     <div className={styles.pagination}>
//       <p>Total {total}</p>
//       <p>Per Page {perPage}</p>
//       <p>
//         {currPage} of {tPage}
//       </p>
//       <div className={styles.pageNum}>
//         <img src={prev_arrow} onClick={updatePage} name="prev" alt="Prev" />
//         {new Array(5).fill(0).map((value, index) => {
//           return (
//             prevPage + index <= tPage && (
//               <span
//                 onClick={updatePage}
//                 key={index}
//                 className={
//                   prevPage + index === currPage ? styles.selectedPage : ""
//                 }
//               >
//                 {prevPage + index}
//               </span>
//             )
//           );
//         })}
//         <img src={next_arrow} onClick={updatePage} name="next" alt="Next" />
//       </div>
//     </div>
//   );
// };

// export const AlertPopup = ({ userBlock }) => {
//   return (
//     <React.Fragment>
//       <div className={commoncss.alertBox}>
//         <h1>Do you realy want to block the user?</h1>
//         <div>
//           <span
//             onClick={userBlock}
//             style={{ backgroundColor: "#019C89", color: "white" }}
//           >
//             Yes
//           </span>
//           <span onClick={userBlock}>No</span>
//         </div>
//       </div>
//       <BackgroundBlur />
//     </React.Fragment>
//   );
// };
